import React from "react";

const phoneNumber = "+971529497677";
const hiddenPathPrefixes = ["/admin", "/booking", "/payment"];

// Booking, payment and admin pages have their own primary actions, so the
// contact bar stays out of the way there.
export function shouldShowMobileContactBar(pathname) {
  return !hiddenPathPrefixes.some((prefix) => pathname.startsWith(prefix));
}

function MobileContactBar() {
  return (
    <nav className="mobileContactBar" aria-label="Contact us">
      <a
        className="mobileContactWhatsApp"
        href={`https://api.whatsapp.com/send?phone=${phoneNumber.slice(1)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg viewBox="0 0 32 32" aria-hidden="true">
          <path d="M16.02 3.2C9 3.2 3.3 8.9 3.3 15.9c0 2.2.6 4.4 1.7 6.3L3.2 28.8l6.8-1.8c1.8 1 3.9 1.5 6 1.5 7 0 12.7-5.7 12.7-12.7S23 3.2 16.02 3.2Zm0 22.9c-1.9 0-3.7-.5-5.3-1.5l-.4-.2-4 1.1 1.1-3.9-.3-.4c-1.1-1.6-1.6-3.5-1.6-5.4 0-5.8 4.7-10.4 10.5-10.4s10.5 4.7 10.5 10.4c0 5.8-4.7 10.5-10.5 10.5Zm5.7-7.8c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.5-.5.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1.1 2.8 1.2 3c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.9-.8 2.1-1.5.3-.7.3-1.3.2-1.5-.1-.1-.3-.2-.6-.4Z" />
        </svg>
        WhatsApp
      </a>
      <a className="mobileContactCall" href={`tel:${phoneNumber}`}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1l-2.3 2.2Z" />
        </svg>
        Call us
      </a>
    </nav>
  );
}

export default MobileContactBar;
